import { View } from './view'

export const assertViewName = <N extends string>(view: View, name: N): View & { name: N } => {
    if (view.name === name) {
        return view as View & { name: N }
    } else {
        throw new Error('Expected view name to be ' + name + ' but was ' + view.name)
    }
}
